import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UserPickupShopsService } from '@checkout/feature';
import { DeviceService } from '@shared/services';
import { Pos } from '@shop/const';
import { ShopListService } from '@shop/feature';
import { Observable } from 'rxjs';

@Component({
  selector: 'sd-pickup-map-select-pos',
  templateUrl: './pickup-map-select-pos.component.html',
  styleUrls: ['./pickup-map-select-pos.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorPickupMapSelectPosComponent implements OnInit {
  shops$: Observable<Pos[]>;
  isTablet$: Observable<boolean>;

  constructor(
    private deviceService: DeviceService,
    private userPickupShopsService: UserPickupShopsService,
    private shopListService: ShopListService,
  ) {}

  ngOnInit(): void {
    this.shops$ = this.shopListService.shops$;
    this.isTablet$ = this.deviceService.isTabletMdDown$;
  }

  onSetShop(shopName: string): void {
    this.userPickupShopsService.add(shopName);
  }
}
